import { Card, CardContent } from '@talentmesh/ui/components/card';
import { TypographyH2 } from '@talentmesh/ui/components/typography';
import React from 'react';
import ActionButtons from '../components/ActionButtons';
import RecruitmentInformation from '../components/RecruitmentInformation';
import UIStrings from '../utils/UIStrings';

export interface RecruitmentCardProps {
    companyName: string;
    tests: Array<string>;
    jobAdTitle: string;
    onBoardUrl: string;
}

function RecruitmentCard({ companyName, tests, jobAdTitle, onBoardUrl }: RecruitmentCardProps): React.JSX.Element {
    return (
        <Card className="sticky top-10 z-10 gap-4 py-4 shadow-lg">
            <CardContent className="flex flex-col gap-4 px-4">
                <TypographyH2>{UIStrings.CompanyIsAFairRecruiter(companyName)}</TypographyH2>
                <RecruitmentInformation tests={tests} />
                <ActionButtons jobAdTitle={jobAdTitle} onBoardUrl={onBoardUrl} />
            </CardContent>
        </Card>
    );
}

export default RecruitmentCard;
